import React, { FC } from "react";
import styled from "styled-components";
import { Table } from "src/components/ui";
import { formatDateDmy, numberWithCommas } from "src/utils";
import { usePagination } from "src/hooks";
import { auth } from "src/store/Auth";
import AppModal from "src/components/ui/widget/Modal/Modal";
import ModalContent from "src/components/common/ModalContent";
import { useEffect, useState } from "react";
import WalletService from "../../service/walletService";
import { toast, ToastContainer } from "react-toastify";

const RecentTransactionsTableContainer = styled.div`
  background-color: ${(props) => props.theme.colors.white};
  margin: 3rem 0;
  border-radius: 16px;
  padding: 20px 0;

  .heading {
    color: ${(props) => props.theme.colors.text_01};
    padding: 0 20px;

    .title {
      font-weight: 600;
      font-size: 22px;
      line-height: 32px;
    }

    .info {
      font-weight: 500;
      font-size: 14px;
      line-height: 24px;
    }
  }

  .table-empty-status {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100px;
    font-weight: 700;
    font-size: 24px;
    font-style: italic;
  }
`;

export const VendorTransactionsTable: FC<{
  rows: VendorWalletTrnxTypes[];
}> = ({ rows }) => {
  const { authUser } = auth.use();
  const [showExportModal, setShowExportModal] = useState(false);
  const [trnx, setTrnx] = useState("");
  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  const [reverse_trnx, setreverse_trnx] = React.useState({
    transaction_id: "",
    type: "credit",
  });

  const submitHandler = (e:any) => {
    e.preventDefault();
    setIsLoading(true);
    WalletService.reverse_payment({
      transaction_id: trnx,
      type: reverse_trnx.type,
    })
      .then((res) => {
        toast.success(res?.data.message);
      })
      .catch((err: any) => {
        toast.error(err.response.error.message);
      })
      .finally(() => {
        setIsLoading(false);
      });

    console.log({
      transaction_id: reverse_trnx.transaction_id,
      type: reverse_trnx.type,
  });}
	
  // ✅ No need for state — compute directly
  const isOccupManager = authUser?.role?.includes("adminManager") ?? false;

  const headers = [
    {
      title: "Purpose",
      render: (row: VendorWalletTrnxTypes) => (
        <p>
          {row.transaction_details?.debited_for ||
            row?.transaction_details?.credited_for ||
            (row?.transaction_details?.customer?.first_name
              ? `${row.transaction_details.customer.first_name} ${row.transaction_details.customer.last_name}`
              : "")}
        </p>
      ),
    },
    {
      title: "Amount",
      render: (row: VendorWalletTrnxTypes) =>
        `₦${numberWithCommas(row?.amount || 0)}`,
    },
    {
      title: "Type",
      render: (row: VendorWalletTrnxTypes) => (
        <p
          className={
            row?.type === "credit" ? "text-[#00cccd]" : "text-[#ffad4a]"
          }
        >
          {row.type}
        </p>
      ),
    },
    {
      title: "Date",
      render: (row: VendorWalletTrnxTypes) =>
        formatDateDmy(row?.created_at) || "",
    },
  ];

  if (isOccupManager) {
    headers.push({
      title: "Reverse",
      render: (row: VendorWalletTrnxTypes) => (
        <span
          style={{ cursor: "pointer", color: "#000" }}
          onClick={() => {
            setShowExportModal(true);
            setTrnx(row?.transaction_details?.tx_ref);
          }}
        >
          {row?.transaction_details?.tx_ref || "-"}
        </span>
      ),
    });
  }

  const { page, limit, Pagination } = usePagination({
    page: 1,
    limit: 5,
    total: rows.length,
  });

  const paginatedRows = rows.slice((page - 1) * limit, page * limit);

  return (
    <RecentTransactionsTableContainer>
      <div className="heading">
        <p className="title">Recent Transactions for Vendors</p>
        <p className="info">Top 10 most recent vendor wallet transactions</p>
      </div>

      {rows.length > 0 ? (
        <Table rows={paginatedRows} headers={headers} showHead={true} />
      ) : (
        <h5 className="table-empty-status">No recent Transaction</h5>
      )}

      <Pagination />

      <AppModal
        open={showExportModal}
        onClose={() => setShowExportModal(false)}
        content={
          <ModalContent
            content1="Reverse"
            content2="Are you sure you want to revese this transaction?"
            btnAction={submitHandler}
            linkContent={"Yes, Please"}
            onClick={() => setShowExportModal(false)}
            loading={false}
          />
        }
      />
    </RecentTransactionsTableContainer>
  );
};

export default VendorTransactionsTable;
